import * as Enums from '../shared/utilities/enums';
import { Note } from '../lesson/models';

export class Tester {
  TestAssignmentId: number;
  LessonAssignmentId: number;
  AssignmentStatusId: number;
  Title: string;
  TestQuestions: TestQuestion[];
  Notes: Note[];
  ElementSubTypeId: Enums.ElementSubType;
  PassingScore: number;
  ModuleTitle: string;
  ModuleAssignmentId: number;
  CourseId: number;

  constructor(obj?: any) {
    this.TestAssignmentId = (obj && obj.TestAssignmentId) || 0;
    this.LessonAssignmentId = (obj && obj.LessonAssignmentId) || 0;
    this.AssignmentStatusId = (obj && obj.AssignmentStatusId) || 0;
    this.Title = (obj && obj.Title) || null;
    this.TestQuestions =
      (obj && obj.TestQuestions && obj.TestQuestions.map(t => new TestQuestion(t))) || null;
    this.Notes = (obj && obj.Notes && obj.Notes.map(t => new Note(t))) || null;
    this.ElementSubTypeId = (obj && obj.ElementSubTypeId) || Enums.ElementSubType.PreTest;
    this.PassingScore = (obj && obj.PassingScore) || 0;
    this.ModuleTitle = (obj && obj.ModuleTitle) || '';
    this.ModuleAssignmentId = (obj && obj.ModuleAssignmentId) || 0;
    this.CourseId = (obj && obj.CourseId) || 0;
  }
}

export class TestAnswer {
  Id: number;
  TestQuestionId: number;
  AnswerText: string;
  IsCorrect: boolean;
  WasPreviousResponse: boolean;

  constructor(obj?: any) {
    this.Id = (obj && obj.Id) || 0;
    this.TestQuestionId = (obj && obj.TestQuestionId) || 0;
    this.AnswerText = (obj && obj.AnswerText) || '';
    this.IsCorrect = (obj && obj.IsCorrect) || false;
    this.WasPreviousResponse = (obj && obj.WasPreviousResponse) || false;
  }
}

export class TestQuestion {
  Id: number;
  QuestionText: string;
  TestId: number;
  TestAnswers: TestAnswer[];
  WasAnsweredCorrectly: boolean;

  constructor(obj?: any) {
    this.Id = (obj && obj.Id) || 0;
    this.QuestionText = (obj && obj.QuestionText) || '';
    this.TestId = (obj && obj.TestId) || 0;
    this.TestAnswers =
      (obj && obj.TestAnswers && obj.TestAnswers.map(t => new TestAnswer(t))) || null;
    this.WasAnsweredCorrectly = (obj && obj.WasAnseredCorrectly) || false;
  }
}

export class Test {
  Id: number;
  TestQuestions: TestQuestion[];
  ModuleId: number;
  ElementSubTypeId: Enums.ElementSubType;
  Title: string;

  constructor(obj?: any) {
    this.Id = (obj && obj.Id) || 0;
    this.TestQuestions =
      (obj && obj.TestQuestions && obj.TestQuestions.map(t => new TestQuestion(t))) || null;
    this.ModuleId = (obj && obj.ModuleId) || 0;
    this.ElementSubTypeId = (obj && obj.ElementSubTypeId) || Enums.ElementSubType.PreTest;
    this.Title = (obj && obj.Title) || '';
  }
}

export class TestAssignment {
  TestAssignmentId: number;
  ModuleAssignmentId: number;
  Test: Test;
  AssignmentStatusId: Enums.AssignmentStatus;
  AssignmentDate: Date;
  StartDate: Date;
  EndDate: Date;
  IsTest = true;
  LessonAssignmentId: number;
  Title: string;
  ElementSubTypeId: Enums.ElementSubType;

  constructor(init?: Partial<TestAssignment>) {
    Object.assign(this, init);
  }
}

export class TestResult {
  HasPassed: boolean;
  Score: number;
  CurrentTestAssignmentId: number;
  RetakeTestAssignmentId: number;

  constructor(obj?: any) {
    this.HasPassed = (obj && obj.HasPassed) || false;
    this.Score = (obj && obj.Score) || 0;
    this.CurrentTestAssignmentId = (obj && obj.CurrentTestAssignmentId) || 0;
    this.RetakeTestAssignmentId = (obj && obj.RetakeTestAssignmentId) || 0;
  }
}
